import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Box, Icon, Text } from '@chakra-ui/react';
import { FiCheck } from 'react-icons/fi';

const SUCCESS_RGB = 'var(--chakra-colors-brand-secondary-rgb)';

const SuccessAnimation = memo(() => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: [0, 1.15, 1] }}
      exit={{ opacity: 0, scale: 0.5 }}
      transition={{ duration: 0.5, ease: [0.2, 1.4, 0.3, 1] }}
      style={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px',
      }}
    >
      <Box
        borderRadius="50%"
        bg="brand.secondary"
        width="60px"
        height="60px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        boxShadow={`0 0 20px rgba(${SUCCESS_RGB}, 0.7)`}
      >
        <Icon as={FiCheck} color="white" boxSize={8} />
      </Box>
      <Text fontWeight="700" color="brand.secondary" fontSize="18px">
        Conversion Successful!
      </Text>
    </motion.div>
  );
});

export default SuccessAnimation;
